import { useState, useEffect } from 'react';
import { getClassificationURL } from '../utils/ConstantsURL';

export const useGetClassification = (token) => {
  const [classifications, setClassifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchClassifications = async () => {
      if (!token) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(getClassificationURL(), {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        
        const transformedData = data.map(item => ({
          id: item.FCLCLAVE,
          name: item.FCLDESCRIPCION
        }));
        
        setClassifications(transformedData);
      } catch (error) {
        console.error('Error fetching classifications:', error);
        setError(error.message);
        setClassifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClassifications();
  }, [token]);

  return {
    classifications,
    loading,
    error
  };
};
